import eco_ai from "../assets/eco_ai.png";
import eco_car from "../assets/eco_car.webp";
import eco_code from "../assets/eco_code.png";
import eco_cogs from "../assets/eco_cogs.png";
import eco_cold_storage from "../assets/eco_cold_storage.png";
import eco_computer from "../assets/eco_computer.png";
import eco_database from "../assets/eco_database.png";
import eco_flask from "../assets/eco_flask.webp";
import eco_office from "../assets/eco_office.png";
import eco_shopping from "../assets/eco_shopping.webp";
import eco_trash from "../assets/eco_trash.png";
import eco_water from "../assets/eco_water.webp";
import bronze_calculator_icon from "../assets/bronze_calculator.png";
import bronze_checklist_icon from "../assets/bronze_checklist_icon.png";
import admin_flask_add from "../assets/admin_flask_add.webp";
import admin_input from "../assets/admin_input.webp";
import admin_user_analyticcs from "../assets/admin_user_analyticcs.webp";
import admin_user_verified from "../assets/admin_user_verified.webp";
import download from "../assets/icon_download.png";
import { Building2, Droplet, FlaskConical, MonitorCog, Popcorn, ShoppingCart, Speaker, ToolCase, Truck } from "lucide-react";


export const icons = {
  eco_ai,
  eco_car,
  eco_code,
  eco_cogs,
  eco_cold_storage,
  eco_computer,
  eco_database,
  eco_flask,
  eco_office,
  eco_shopping,
  eco_trash,
  eco_water,
  bronze_calculator_icon,
  bronze_checklist_icon,
  admin_flask_add,
  admin_input,
  admin_user_analyticcs,
  admin_user_verified,
  download,
  labWaste: <Popcorn />,
  coldStorage: <Speaker />,
  computerHardware: <MonitorCog />,
  transport: <Truck />,
  greenChemistry: <FlaskConical />,
  procurement: <ShoppingCart />,
  ecoOffice: <Building2 />,
  equipment: <ToolCase />,
  water: <Droplet />
};

// Tier-specific icon mappings for certification levels
export const tierIcons = {
  bronze: {
    calculator: bronze_calculator_icon,
    checklist: bronze_checklist_icon,
  },
  silver: {
    calculator: bronze_calculator_icon, // Placeholder - reuse bronze for now
    checklist: bronze_checklist_icon,   // Placeholder - reuse bronze for now
  },
  gold: {
    calculator: bronze_calculator_icon, // Placeholder - reuse bronze for now
    checklist: bronze_checklist_icon,   // Placeholder - reuse bronze for now
  },
};

// Tier color configurations for UI styling
export const tierColors = {
  bronze: {
    primary: '#BC7F48',
    light: '#f7c495',
    text: '#bc7f48',
    bg: 'bg-amber-100',
    buttonBg: 'bg-[#f7c495]',
    buttonHover: 'hover:bg-[#f7c495cc]',
  },
  silver: {
    primary: '#9E9E9E',
    light: '#C0C0C0',
    text: '#6E6E6E',
    bg: 'bg-gray-100',
    buttonBg: 'bg-[#C0C0C0]',
    buttonHover: 'hover:bg-[#B0B0B0]',
  },
  gold: {
    primary: '#D4A017',
    light: '#F5C91B',
    text: '#A68312',
    bg: 'bg-yellow-100',
    buttonBg: 'bg-[#F5C91B]',
    buttonHover: 'hover:bg-[#E5B82A]',
  },
};
